import { forwardRef } from "react";
import { Combobox } from "@headlessui/react";
import classNames from "classnames";
import { Icon } from "@circle-react-shared/Icon";

export interface ClearButtonProps {
  className?: string;
  onClick?: () => void;
}

export const ClearButton = forwardRef<HTMLButtonElement, ClearButtonProps>(
  ({ className, onClick }, ref) => (
    <Combobox.Button
      ref={ref}
      className={classNames(
        "text-dark absolute inset-y-0 right-0 flex items-center pr-4 disabled:!cursor-not-allowed disabled:!opacity-40",
        className,
      )}
      onClick={onClick}
    >
      <Icon type="20-cross" size={20} className="!h-4 !w-4" />
    </Combobox.Button>
  ),
);

ClearButton.displayName = "ClearButton";
